// extracted by mini-css-extract-plugin
module.exports = {"root":"StreamsList_root__X34mX","infoWrapper":"StreamsList_infoWrapper__A4hHD"};